const { FormattedDescription } = require('./_FormattedDescription');

module.exports = FormattedDescription;